import { Link } from 'react-router';
import { ChevronRight, ChevronLeft } from 'lucide-react';

interface BreadcrumbProps {
  paths: { name: string; link?: string }[];
  className?: string;
  backStatus?: string;
}

export default function Breadcrumb({ backStatus = 'flex', paths, className = 'text-text' }: BreadcrumbProps) {
  return (
    <nav className={`${className} flex items-center text-sm gap-4`}>
      {paths.length > 1 && paths[paths.length - 2].link && (
        <Link
          to={paths[paths.length - 2].link!}
          className={`${backStatus} items-center gap-4 text-secondary text-xs sm:text-base`}
        >
          <div className="flex gap-1 items-center">
            <ChevronLeft size={16} className="mr-1" />
            Back
          </div>
          <div className="w-2 h-2 rounded-full bg-slate-100" />
        </Link>
      )}
      <div className="gap-1.5 sm:gap-2.5 flex">
        {paths.map((path) => {
          const isLast = path === paths[paths.length - 1];

          return (
            <div key={path.name} className="flex items-center gap-1.5 sm:gap-2.5 text-xs sm:text-base">
              {path !== paths[0] && <ChevronRight size={16} className="text-gray-400" />}
              {isLast ? (
                <span className="font-medium">{path.name}</span>
              ) : (
                <Link to={path.link || '#'} className="opacity-70 hover:opacity-100">
                  {path.name}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
}
